import { useContext, useEffect, useState } from "react";

import Button from "react-bootstrap/Button";

import Text from "/src/components/common/Form/Text";
import MagnifyingGlass from "/src/components/common/Icon/MagnifyingGlass";

function shouldRender() {
  return true;
}

function Component({ onChange, onSubmit, value, ...otherProps }) {

  const handleChange = (text) => {
    if (typeof onChange === "function") {
      onChange(text);
    }
  }

  const handleKeyPress = (event) => {
    if (event.charCode === 13) {
      if (typeof onSubmit === "function") {
        onSubmit();
      }
    }
  }

  if (shouldRender()) {
    return (
      <Text
        {...otherProps}
        style={{ minWidth: 0, height: 36 }}
        prepend={<MagnifyingGlass />}
        placeholder={"Enter to search"}
        onKeyPress={handleKeyPress}
        onChange={handleChange}
        value={value || ""}
      />
    );
  }

  return null;

}

export default Component;
